import { useTranslation } from 'react-i18next';

/**
 * Familie und Community (27.10.2026): vorerst ehrliche Startseiten. Sie sagen,
 * was der Raum wird, und ausdrücklich, dass es noch nichts zu bedienen gibt —
 * ein leerer Raum sähe aus wie eine Antwort, ein Knopf ohne Wirkung wie eine
 * Funktion. Gebaut wird erst auf Ansage (docs/ideen.md).
 */
export function FamilyRoom({
  onOpenHouseholdPlan,
}: {
  /** Nur mit Haushalt und Planen — sonst gibt es den Weg nicht. */
  onOpenHouseholdPlan?: (() => void) | undefined;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="family-room" className="flex flex-col gap-3">
      <div className="kw-tile flex flex-col gap-2">
        <h2 id="family-room" className="font-display text-2xl font-bold">
          {t('familyRoom.heading')}
        </h2>
        <p className="text-sm">{t('familyRoom.intro')}</p>
      </div>
      <section aria-labelledby="family-room-coming" className="kw-tile flex flex-col gap-2">
        <h3 id="family-room-coming" className="kw-kicker">
          {t('familyRoom.comingHeading')}
        </h3>
        <ul className="flex list-disc flex-col gap-1 pl-5 text-sm">
          <li>{t('familyRoom.comingInvite')}</li>
          <li>{t('familyRoom.comingEvents')}</li>
          <li>{t('familyRoom.comingTasks')}</li>
        </ul>
        <p role="status" className="text-sm text-ink-muted">
          {t('familyRoom.notYet')}
        </p>
      </section>
      <section aria-labelledby="family-room-meanwhile" className="kw-tile flex flex-col gap-2">
        <h3 id="family-room-meanwhile" className="kw-kicker">
          {t('familyRoom.meanwhileHeading')}
        </h3>
        <p className="text-sm">{t('familyRoom.meanwhile')}</p>
        {onOpenHouseholdPlan ? (
          <button
            type="button"
            onClick={onOpenHouseholdPlan}
            className="kw-btn kw-btn-quiet kw-btn-small"
          >
            {t('familyRoom.toHouseholdPlan')}
          </button>
        ) : null}
      </section>
    </section>
  );
}

export function CommunityRoom(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="community-room" className="flex flex-col gap-3">
      <div className="kw-tile flex flex-col gap-2">
        <h2 id="community-room" className="font-display text-2xl font-bold">
          {t('communityRoom.heading')}
        </h2>
        <p className="text-sm">{t('communityRoom.intro')}</p>
      </div>
      <section aria-labelledby="community-room-coming" className="kw-tile flex flex-col gap-2">
        <h3 id="community-room-coming" className="kw-kicker">
          {t('communityRoom.comingHeading')}
        </h3>
        <p className="text-sm">{t('communityRoom.comingRecipes')}</p>
        <p className="text-sm text-ink-muted">{t('communityRoom.openNote')}</p>
        <p role="status" className="text-sm text-ink-muted">
          {t('communityRoom.notYet')}
        </p>
      </section>
    </section>
  );
}
